export const formatMask = (inputNumber, mask) => {
  if (mask.length < 1) {
    return inputNumber;
  }
  let index = 0;
  let formattedNumber = '';
  for (let i = 0; i < mask.length; i++) {
    if (mask[i] === '#') {
      formattedNumber += inputNumber[index] || ' '; // Если цифры закончились, оставляем пустую строку
      index++;
    } else {
      // Если символ маски не '#', добавляем его как есть
      formattedNumber += mask[i];
    }
  }
  return formattedNumber;
}
